import { FC, useLayoutEffect } from 'react';

export type ScrollToTopProps = {
  /**
   * trigger that should cause all toasts to be cleared (e.g. pathname)
   */
  trigger?: unknown;
};

export const ScrollToTop: FC<ScrollToTopProps> = ({ trigger }) => {
  // Reset scroll position when path is changed
  useLayoutEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [trigger]);

  return null;
};
